import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Conecta from '../../components/Conecta'
import Manager from '../../components/Manager'
import Leader from '../../components/Leader'
import { useQueryParams } from '../../hooks/useQueryParams'
import Denied from '../../components/Denied'

const Home = () => {
  const { profile } = useParams()
  const [user, setUser ] = useState("")
  const [userName, setUserName] = useState("")
  const [idBranch, setIdBranch] = useState()
  const queries = useQueryParams();

  function identyProfile(profile) {
    setUserName(`${queries['name']} ${queries['lastname']}`)
    if (profile == 161){
      setUser("Contact Center")
    } else if (profile == 13){
      setUser("Gerente")
      setIdBranch(queries['branch'])
    } else if (profile == 162 || profile == 148 ){
      setUser("Lider")
    }else if (profile == 23 ){
      setUser("Sistemas")
    }else if (profile == 52 ){
      setUser("Director Comercial")
    }else if (profile == 119 ){
      setUser("Gerente de Sistemas")
    }
  }

  useEffect(() => {
    identyProfile(profile);
    
  }, [profile, queries])

 //console.log(userName)

  return (
    <div className='px-6 mt-20'>
     {(user === "Contact Center" ? <Conecta user={user} userName ={userName}/> : 
     user === "Gerente" ? <Manager user={user} userName ={userName} idBranch ={idBranch}/>: 
     (user === "Lider" || user === "Sistemas" || user === "Director Comercial" || user === "Gerente de Sistemas" ) ? <Leader user={user} userName ={userName}/>: <Denied/>
     )}
    </div>
  )
}

export default Home